<template>
  <div class="px-2 lg:px-4 py-2">
    <PBreadcrumb :parts="parts" current-page-label="Plan du site" />
    <div class="flex justify-around w-full py-6">
      <div class="flex flex-col items-start gap-5">
        <h1 class="text-h1 font-bold">Plan du site</h1>
        <ul class="flex flex-col gap-4">
          <li>
            <PLink to="/">
              Accueil
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
          <li>
            <PLink to="/user-guide">
              Guide d'utilisation
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
          <li class="ml-4">
            <PLink to="/sign-help">
              Page d'aide à la signature certifiée
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
          <li>
            <PLink to="/?archived=false">
              Recherche avancée
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
          <li>
            <PLink to="/site-map">
              Plan du site
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
          <li>
            <PLink to="/personnal-data">
              Données personnelles
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
          <li>
            <PLink to="/contact">
              Contact
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
          <li>
            <PLink to="/versions">
              Version du site
              <OhVueIcon :name="arrowIcon" class="ml-1v" />
            </PLink>
          </li>
        </ul>
      </div>
      <div class="hidden xl:block mt-4">
        <div class="w-[15rem] h-[15rem] bg-grey-975 rounded-full -skew-x-6 p-6">
          <div
            class="bg-no-repeat bg-cover bg-center w-full h-full skew-x-6"
            :style="`background-image: url(/box.svg);`"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PBreadcrumb, useIcons, PLink } from "@pasta/box-v2";
import { RiArrowRightLine } from "oh-vue-icons/icons";
import { OhVueIcon } from "oh-vue-icons";

const parts = [{ label: "Accueil", to: "/" }];
const [arrowIcon] = useIcons(RiArrowRightLine);
</script>
